/*=============================================== Breadcrumbs ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { v4 as uuid } from "uuid";
import Variables from "./Variables";
import Mixins from "./Mixins";
import FajnyIcon from "./FajnyIcon";
import { P } from "./Font";
/*==================== Component ====================*/
var Breadcrumbs = function (_a) {
    var items = _a.items, _b = _a.separator, separator = _b === void 0 ? "slash" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, props = __rest(_a, ["items", "separator", "color"]);
    return (React.createElement(Container, __assign({ "$color": color }, props), items.map(function (_a) {
        var text = _a.text, to = _a.to;
        return (React.createElement(Item, { as: to ? Link : "span", to: to ? to : undefined, key: uuid() },
            text,
            to && (React.createElement(Separator, { "$color": color }, separator === "icon" ? (React.createElement(FajnyIcon, { name: "chevron-right-solid", size: 12 })) : ("/")))));
    })));
};
export default Breadcrumbs;
/*==================== Styles ====================*/
var Container = styled(P)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n\n    ", "\n"], ["\n    ", ";\n\n    ", "\n"])), Mixins.Flexbox({
    $align: "center",
    $justify: "flex-start",
    $wrap: "wrap",
    $gap: "xxs",
}), function (_a) {
    var $color = _a.$color;
    return $color && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            color: ", ";\n\n            a {\n                color: ", ";\n\n                @media ", " {\n                    &:hover {\n                        color: ", ";\n                    }\n\n                    &:active {\n                        color: ", ";\n                    }\n                }\n            }\n        "], ["\n            color: ", ";\n\n            a {\n                color: ", ";\n\n                @media ", " {\n                    &:hover {\n                        color: ", ";\n                    }\n\n                    &:active {\n                        color: ", ";\n                    }\n                }\n            }\n        "])), $color === "white" ? Variables.Colors.White : Variables.Colors.Black, Mixins.ColorsHoverDefault, Variables.Breakpoints.Hover, Mixins.ColorsHoverHover, Mixins.ColorsHoverActive);
});
var Separator = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    margin-left: ", ";\n    position: relative;\n"], ["\n    color: ", ";\n    margin-left: ", ";\n    position: relative;\n"])), function (_a) {
    var $color = _a.$color;
    return ($color === "white" ? Variables.Colors.White : Variables.Colors.Black);
}, Variables.Spacers.XXS);
var Item = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    @media ", " {\n        &:hover ", ", &:active ", " {\n            color: ", ";\n        }\n    }\n"], ["\n    @media ", " {\n        &:hover ", ", &:active ", " {\n            color: ", ";\n        }\n    }\n"])), Variables.Breakpoints.Hover, Separator, Separator, Variables.Colors.Black);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
